import {createContext, PropsWithChildren, useContext, useState} from 'react';

type ValidationState = {
  formError: string | null;
  setFormError: (error: string | null) => void;
  formWarning: string | null;
  setFormWarning: (warning: string | null) => void;
  fieldErrors: Record<string, string>;
  setFieldErrors: (errors: Record<string, string>) => void;
};

const ValidationContext = createContext<ValidationState>(null as never);

export const useValidationContext = () => {
  const context = useContext(ValidationContext);

  if (!context) {
    throw new Error('useValidationContext must be used within a ValidationProvider');
  }

  return context;
};

export const ValidationProvider = ({children}: PropsWithChildren) => {
  const [formError, setFormError] = useState<string | null>(null);
  const [formWarning, setFormWarning] = useState<string | null>(null);
  const [fieldErrors, setFieldErrors] = useState<Record<string, string>>({});

  return (
    <ValidationContext.Provider
      value={{
        formError,
        setFormError,
        formWarning,
        setFormWarning,
        fieldErrors,
        setFieldErrors,
      }}
    >
      {children}
    </ValidationContext.Provider>
  );
};
